module.exports = __webpack_public_path__ + "static/media/uparrow.2d619400.svg";